<template>
  <div
    class="ms-auto w-md-auto mt-2"
    v-if="ClamIdentifie !== 'igenyazonosito' && !$store.state.igeny_azon_href && $store.state.page >= showFromPage"
  >
    <button @click="generateClaimIdentifier('igenyazonosito')" class="btn btn-red claim-identifier">
      Díjszámítási pdf létrehozása
    </button>
  </div>
  <div
    class="ms-auto w-md-auto mt-2"
    v-else-if="$store.state.igeny_azon_href && $store.state.page >= showFromPage"
  >
    <a :href="$store.state.igeny_azon_href" target="_blank" class="btn btn-red claim-identifier"
      >Díjszámítás letöltése pdf-ben</a
    >
  </div>
  <div
    class="ms-auto w-md-auto mt-2"
    v-else-if="$store.state.page >= showFromPage && !$store.state.igeny_azon_href"
  >
    <button class="btn btn-red claim-identifier">
      Kérem várjon
    </button>
  </div>
</template>

<script>
export default {
  props: ['showFromPage'],
  methods: {
    generateClaimIdentifier(code) {
      this.$store.commit('setClaimIdentifier', code);
      this.$store.dispatch('verifyPage');
      this.$store.commit('setNavigationBackButton', true);
    },
  },
  computed: {
    ClamIdentifie() {
      return this.$store.state.code;
    },
  },
};
</script>
